var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgGoramp = function SvgGoramp(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    viewBox: "0 0 200 200"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#8799AE"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M83.15 37.05C34.9 49.7 18.8 109.4 54 145.1c40.85 41.5 110.25 12.8 110.4-45.6.1-42.25-40.2-73.2-81.25-62.45M108.8 59.5c31.7 7.5 43 46.45 20.05 69.35-16.25 16.25-42 16.15-58.4-.3C41.5 99.65 69 50.15 108.8 59.5"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M90.25 80.05c-21.1 10.7-13.9 41.45 9.75 41.45 28.6 0 29.7-41.85 1.1-43.3-5.25-.25-7.5.15-10.85 1.85"
  }))));
};
export default SvgGoramp;